/**
 * FlowUnlinkedCard — Flow sub-tab hint for a group that has no tracker
 * campaign linked yet. Voluum / Binom keep their shared copy; another tracker
 * names itself.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Workflow } from 'lucide-react';
import { matchTracker, trackerLabel, type TrackerId } from '@trafficpulse/shared';

import { Card, CardContent } from '@/components/ui';

const LEGACY_HINT = 'Link a Voluum or Binom campaign to use the Flow Optimizer.';

function unlinkedHint(tracker: TrackerId): string {
  return matchTracker(tracker, {
    voluum: () => LEGACY_HINT,
    binom: () => LEGACY_HINT,
    'tres-commas': () => `Link a ${trackerLabel(tracker)} campaign to use the Flow Optimizer.`,
  });
}

interface FlowUnlinkedCardProps {
  tracker: TrackerId;
}

export const FlowUnlinkedCard: FC<FlowUnlinkedCardProps> = ({ tracker }) => (
  <Card>
    <CardContent className="py-8 text-center text-muted-foreground">
      <Workflow className="h-12 w-12 mx-auto mb-4 opacity-50" />
      <p>{unlinkedHint(tracker)}</p>
    </CardContent>
  </Card>
);

export default FlowUnlinkedCard;
